import api from "./index.js";

export const getHomepageEventInfoService = async (eventId, params = {}) => {
  return await api.get(`/client/homepage/event/${eventId}`, {
    params,
  });
};

// Modulo -> acao ja existente no enum ApplicationLog.Action do backend.
const CLIENT_HOMEPAGE_ACCESS_ACTIONS = {
  CHECKLIST: "ACCESS_CLIENT_HOMEPAGE_CHECKLIST",
  ACADEMY: "ACCESS_CLIENT_HOMEPAGE_ACADEMY",
  MANUAL: "ACCESS_CLIENT_HOMEPAGE_MANUAL",
  ECOMMERCE: "ACCESS_CLIENT_HOMEPAGE_ECOMMERCE",
};

export const registerHomepageModuleAccessService = async (eventId, module) => {
  const action = CLIENT_HOMEPAGE_ACCESS_ACTIONS[module];

  return await api.post("/log/client-homepage-access", null, {
    params: { eventId, action },
  });
};
